import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowLeft_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7071 5.29289C15.0976 5.68342 15.0976 6.31658 14.7071 6.70711L6.41421 15H28C28.5523 15 29 15.4477 29 16C29 16.5523 28.5523 17 28 17H6.41421L14.7071 25.2929C15.0976 25.6834 15.0976 26.3166 14.7071 26.7071C14.3166 27.0976 13.6834 27.0976 13.2929 26.7071L3.29289 16.7071C2.90237 16.3166 2.90237 15.6834 3.29289 15.2929L13.2929 5.29289C13.6834 4.90237 14.3166 4.90237 14.7071 5.29289Z"
            />
        </SvgStyled>
    );
};

export default ArrowLeft_lg;
